import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ppb-e404',
  templateUrl: './e404.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E404Component { }
